import React from 'react'

import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Card';
import '../cssfiles/cardsgroup.css'
import {CartState} from '../context/contextmen'
function Women() {
    
    const { dispatch} = CartState();
    const {state: { womenproducts }, productState: { sort ,searchQuery} } = CartState();

    const transformProducts = () => {
        let sortedProducts = womenproducts;
    
        if (sort) {
          sortedProducts = sortedProducts.sort((a, b) =>
            sort === "lowToHigh" ? a.price - b.price : b.price - a.price
          );
        }
        if (searchQuery) {
            sortedProducts = sortedProducts.filter((prod) =>
              prod.name.toLowerCase().includes(searchQuery)
            );
          }
      
        return sortedProducts;
      }
    


  return (   <div> <h1 className='heading'>WOMENS WEAR</h1> 
   {transformProducts().map((obj,index)=>{
    
    return <div className='display'><Card key={index} style={{ width: '18rem' }}  className="cards">
    <Card.Img variant="top" src={ obj.Image } alt="PRODUCT" className='imagees'/>
    <Card.Body>
      <Card.Title>{obj.name}</Card.Title>
      <Card.Text>
      ${obj.price}
      </Card.Text>
      <Card.Text>
      {obj.description}
      </Card.Text>
      <Button className='btn btn-primary active' onClick={()=> dispatch({type : 'ADD_TO_CART', payload: obj})}>Add to cart</Button>
    </Card.Body>
    </Card></div>
   })} 
    </div>
  )
}

export default Women